/* cg-r55.js (R55, Oct 22 2026; R56 hardening Oct 23 2026). Customer journey fixes. Loaded last from
   snippets/card-description-clamp.liquid.
   R56: the paint loop no longer rewrites the banner every 120 ms, skips script/style text, and only watches
   DOM inserts (not every class change on the page). */
(function () {
  'use strict';
  if (window.__cgR55) return; window.__cgR55 = true;
  var DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DAYK = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function clock(h, m) { return (h % 12 || 12) + ':' + pad(m) + ' ' + (h >= 12 ? 'PM' : 'AM'); }
  function isoParts(iso) { return /^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)/.exec(String(iso || '')); }
  function label(iso) {
    var m = isoParts(iso); if (!m) return '';
    var d = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]));
    return DOW[d.getUTCDay()] + ', ' + MON[+m[2] - 1] + ' ' + (+m[3]) + ', ' + clock(+m[4], +m[5]);
  }
  function todayKey() {
    var o = {};
    new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date()).forEach(function (x) { o[x.type] = x.value; });
    return o.year + '-' + o.month + '-' + o.day;
  }

  /* ---------- 1. one consistent time on the cart ---------- */
  function norm(a) {
    if (!a || typeof a !== 'object' || a['Catering Order'] === 'Yes') return a;
    if (/cater/i.test(String(a['Channel'] || ''))) return a;
    if (!('Pickup Time ISO' in a) && !('Requested Time' in a) && !('Pickup Time' in a)) return a;
    if (a['Channel'] === 'restaurant') a['Headcount'] = '';
    var iso = String(a['Pickup Time ISO'] || ''), m = isoParts(iso), asap;
    if ('Pickup Time' in a && a['Pickup Time']) asap = a['Pickup Time'] === 'ASAP';
    else if ('Requested Time' in a && a['Requested Time']) asap = a['Requested Time'] === 'ASAP';
    else asap = a['Order Timing'] === 'ASAP';
    if (!asap && m) {
      a['Order Timing'] = 'Scheduled';
      a['Requested Time'] = label(iso);
      a['Scheduled Date'] = m[1] + '-' + m[2] + '-' + m[3];
      a['Scheduled Time'] = clock(+m[4], +m[5]);
    } else if (asap) {
      a['Order Timing'] = 'ASAP'; a['Requested Time'] = 'ASAP'; a['Scheduled Date'] = ''; a['Scheduled Time'] = '';
    }
    return a;
  }
  var of = window.fetch;
  if (of && !of.__cgR55) {
    var w = function (url, opts) {
      var u = typeof url === 'string' ? url : (url && url.url) || '';
      try {
        if (/\/cart\/update(\.js)?(\?|$)/.test(u) && opts && typeof opts.body === 'string' && opts.body.charAt(0) === '{') {
          var b = JSON.parse(opts.body);
          if (b && b.attributes) { b.attributes = norm(b.attributes); opts = Object.assign({}, opts, { body: JSON.stringify(b) }); }
        }
      } catch (e) {}
      var p = of.apply(this, [url, opts]);
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(u)) p.then(function () { setTimeout(loadCart, 400); }).catch(function () {});
      return p;
    };
    Object.keys(of).forEach(function (k) { w[k] = of[k]; }); w.__cgR55 = true; window.fetch = w;
  }

  /* ---------- cart state (for tips and the separate-checkout banner) ---------- */
  var cart = null, caterIds = null;
  function loadCart() {
    return of('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { cart = c; paint(); return c; }).catch(function () {});
  }
  function loadCater() {
    if (caterIds) return Promise.resolve(caterIds);
    try { var s = sessionStorage.getItem('cg_r55_cater'); if (s) { caterIds = JSON.parse(s); return Promise.resolve(caterIds); } } catch (e) {}
    var ids = {};
    function page(n) {
      return of('/collections/catering/products.json?limit=250&page=' + n).then(function (r) { return r.json(); }).then(function (j) {
        (j.products || []).forEach(function (p) { ids[p.id] = 1; });
        if ((j.products || []).length === 250 && n < 4) return page(n + 1);
      });
    }
    return page(1).then(function () { caterIds = ids; try { sessionStorage.setItem('cg_r55_cater', JSON.stringify(ids)); } catch (e) {} return ids; }, function () { caterIds = {}; return caterIds; });
  }
  function isCaterItem(it) { return !!(caterIds && caterIds[it.product_id]) || /cater/i.test((it.product_type || '') + ' ' + (it.product_title || '')); }
  function isTip(it) { return /^tip$/i.test(it.product_title || '') || /tip/i.test(it.product_type || ''); }

  /* ---------- 2. one pop-up: menu panel Check out goes straight to checkout ---------- */
  function go() { location.href = '/checkout'; }
  window.addEventListener('click', function (e) {
    var co = e.target && e.target.closest && e.target.closest('.cgm-panel .cgm-checkout');
    if (!co || !window.CGMenu || !CGMenu.attributes) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var at = CGMenu.attributes();
    if (!at['Pickup Time ISO'] || co.classList.contains('is-blocked')) {
      var pn = document.querySelector('.cgm-panel'); if (pn) pn.classList.remove('is-open');
      document.body.style.overflow = '';
      CGMenu.openSetup();
      return;
    }
    try { sessionStorage.setItem('cg_time_ok', '1'); } catch (x) {}
    co.textContent = 'One sec…';
    window.fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: at }) }).then(go, go);
  }, true);

  /* ---------- 3 + 4. copy and time slots ---------- */
  var OLD = /The kitchen stops taking orders 0 minutes before close\. Schedule one for tomorrow\./g;
  var NEW = 'We are closed for today. Schedule your order for tomorrow.';
  var PTS = /,? points on every order/g;
  function fixText(root) {
    var tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: function (n) { var pe = n.parentNode && n.parentNode.nodeName; return pe === 'SCRIPT' || pe === 'STYLE' || pe === 'TEXTAREA' ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT; } }), t;
    while ((t = tw.nextNode())) {
      var v = t.nodeValue, nv = v.replace(OLD, NEW).replace(PTS, '');
      OLD.lastIndex = 0; PTS.lastIndex = 0;
      if (nv !== v) t.nodeValue = nv;
    }
  }
  var DESC = 'Order online right here for pickup, usually ready in about 15 minutes, or local delivery in about 35 to 45 minutes. Or come dine in with us.';
  function fixDesc() {
    document.querySelectorAll('p').forEach(function (p) {
      if (p.__r55) return;
      if (/^Order online for pickup or delivery (at|on) /.test((p.textContent || '').trim())) { p.__r55 = 1; p.textContent = DESC; }
    });
  }
  function closeFor(key) {
    var C = window.CGM_CONFIG || {}, ov = null;
    (C.holidays || []).forEach(function (h) { if (h && h.date === key) ov = h; });
    var hm = function (s) { var a = String(s || '').split(':'); return (+a[0] || 0) * 60 + (+a[1] || 0); };
    if (ov) return ov.close ? hm(ov.close) : 0;
    var p = key.split('-'), d = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2])), h = (C.hours || {})[DAYK[d.getUTCDay()]];
    return h && h[1] ? hm(h[1]) : 0;
  }
  function trimSlots() {
    var su = document.querySelector('.cgm-setup.is-open'); if (!su) return;
    var ds = su.querySelector('[data-date]'), ts = su.querySelector('[data-time]'); if (!ds || !ts || !ds.value) return;
    var close = closeFor(ds.value); if (!close) return;
    var last = close - 15, removed = false;
    Array.prototype.slice.call(ts.options).forEach(function (o) { if (+o.value > last && ts.options.length > 1) { o.remove(); removed = true; } });
    if (removed && !ts.value && ts.options.length) ts.selectedIndex = 0;
  }
  function dropStale() {
    if (!window.CGMenu || !CGMenu.setup) return false;
    var s = CGMenu.setup();
    if (s && s.when !== 'asap' && s.date && s.date < todayKey()) { s.date = ''; s.time = 0; try { localStorage.setItem('cgm_setup_v1', JSON.stringify(s)); } catch (e) {} }
    return true;
  }

  /* ---------- 5. one clear line under Check out ---------- */
  function tipHtml() {
    if (!cart || !cart.item_count) return '';
    var a = cart.attributes || {};
    if (a['Catering Order'] === 'Yes' || a['Channel'] !== 'restaurant') return '';
    var del = a['Order Type'] === 'Delivery', asap = a['Order Timing'] === 'ASAP' || a['Requested Time'] === 'ASAP';
    var when = asap ? (del ? 'ASAP, arrives in about 35 to 45 min' : 'ASAP, ready in about 15 min') : (a['Requested Time'] || '');
    if (!when) return '';
    return del
      ? '<b>Delivery ' + when + '.</b> At checkout, tap <b>Delivery</b> and enter your address.'
      : '<b>Pickup ' + when + '.</b> At checkout, tap <b>Pickup</b>. Ignore Shopify’s standard “ready in 1 hour” line, we go by your time.';
  }
  var SEL = '.cgm-panel .cgm-checkout, #checkout, #CartDrawer-Checkout';
  function paintTips() {
    var html = tipHtml();
    document.querySelectorAll(SEL).forEach(function (b) {
      var host = b.parentNode; if (!host) return;
      var t = host.querySelector(':scope > .cg-r55-tip');
      if (!html) { if (t) t.remove(); return; }
      if (!t) { t = document.createElement('p'); t.className = 'cg-r55-tip'; b.insertAdjacentElement('afterend', t); }
      if (t.__h !== html) { t.__h = html; t.innerHTML = html; }
    });
  }

  /* ---------- 6. restaurant and catering check out separately ---------- */
  var path = location.pathname.toLowerCase();
  var onCater = /^\/(collections\/catering|pages\/catering|pages\/holiday-catering|pages\/corporate-catering)/.test(path);
  var onMenu = /^\/pages\/food-menu-new/.test(path);
  function paintBanner() {
    var old = document.getElementById('cg-r55-split');
    if (!cart || !cart.items || (!onCater && !onMenu) || !caterIds) { if (old) old.remove(); return; }
    var other = cart.items.filter(function (it) { return !isTip(it) && (onCater ? !isCaterItem(it) : isCaterItem(it)); });
    if (!other.length) { if (old) old.remove(); return; }
    var n = other.reduce(function (s, i) { return s + i.quantity; }, 0);
    var kind = onCater ? 'restaurant' : 'catering';
    var html = '<div class="cg-r55-split__in"><p><b>Your order has ' + n + ' ' + kind + ' item' + (n === 1 ? '' : 's') + '.</b> ' +
      (onCater ? 'Catering orders' : 'Restaurant orders') + ' check out on their own, so the kitchen gets the right time and rules.</p>' +
      '<div class="cg-r55-split__btns"><button type="button" data-r55-clear>Remove them and continue</button>' +
      '<a href="' + (onCater ? '/pages/food-menu-new' : '/collections/catering') + '">Back to my ' + kind + ' order</a></div></div>';
    if (!old) { old = document.createElement('div'); old.id = 'cg-r55-split'; old.className = 'cg-r55-split'; var main = document.querySelector('main') || document.body; main.insertBefore(old, main.firstChild); }
    if (old.__h !== html) { old.__h = html; old.innerHTML = html; }
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-r55-clear]'); if (!b || !cart) return;
    var updates = {};
    cart.items.forEach(function (it) { if (!isTip(it) && (onCater ? !isCaterItem(it) : isCaterItem(it))) updates[it.key] = 0; });
    b.disabled = true; b.textContent = 'One sec…';
    of('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, attributes: { 'Channel': '', 'Order Type': '', 'Requested Time': '', 'Pickup Time ISO': '', 'Order Timing': '', 'Scheduled Date': '', 'Scheduled Time': '', 'Catering Order': '' } }) })
      .then(function () { try { localStorage.removeItem('cgm_setup_v1'); sessionStorage.removeItem('cg_time_ok'); } catch (x) {} location.reload(); }, function () { location.reload(); });
  });

  /* ---------- paint loop ---------- */
  var busy = false;
  function paint() {
    if (busy) return; busy = true;
    try { fixText(document.body); fixDesc(); trimSlots(); paintTips(); paintBanner(); } catch (e) {}
    busy = false;
  }
  var css = document.createElement('style');
  css.textContent = '.cg-co-tip{display:none!important}' +
    '.cg-r55-tip{margin:8px 0 0;font-size:13px;line-height:1.45;color:#4a4642;text-align:left}.cg-r55-tip b{color:#1B1919}' +
    '.cg-r55-split{background:#FFF3D6;border-bottom:1px solid rgba(27,25,25,.12)}' +
    '.cg-r55-split__in{max-width:1200px;margin:0 auto;padding:12px 16px;display:flex;flex-wrap:wrap;gap:10px 16px;align-items:center;justify-content:space-between;font:14px/1.45 Lato,Arial,sans-serif;color:#1B1919}' +
    '.cg-r55-split__in p{margin:0;flex:1 1 320px}' +
    '.cg-r55-split__btns{display:flex;gap:10px;flex-wrap:wrap}' +
    '.cg-r55-split__btns button{border:0;border-radius:999px;background:#1B1919;color:#fff;font:700 14px/1 Lato,Arial,sans-serif;padding:11px 16px;cursor:pointer}' +
    '.cg-r55-split__btns a{border:2px solid #1B1919;border-radius:999px;color:#1B1919;text-decoration:none;font:700 14px/1 Lato,Arial,sans-serif;padding:9px 14px}' +
    'body:has(.cgc-nav) .section-header{position:relative!important;top:0!important}';
  (document.head || document.documentElement).appendChild(css);

  function boot() {
    var tries = 0, t = setInterval(function () { if (dropStale() || ++tries > 40) clearInterval(t); }, 250);
    loadCater().then(paint);
    loadCart();
    var mt; new MutationObserver(function () { if (busy) return; clearTimeout(mt); mt = setTimeout(paint, 120); })
      .observe(document.body, { childList: true, subtree: true });
    document.addEventListener('change', function (e) { if (e.target && e.target.matches && e.target.matches('.cgm-setup [data-date]')) setTimeout(trimSlots, 30); }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* R55b (Oct 23 2026): Thanksgiving carts schedule for Thu Nov 26 only, 10 AM to 6:30 PM, no ASAP. */
(function () {
  var ISO = '2026-11-26', FULL = 'Thu, Nov 26', FIRST = 600, LAST = 1110, STEP = 15, tg = false;
  function fmt(m) { var h = Math.floor(m / 60), mm = m % 60; return (h % 12 || 12) + ':' + (mm < 10 ? '0' : '') + mm + ' ' + (h >= 12 ? 'PM' : 'AM'); }
  function isTG(c) { return (c.items || []).some(function (i) { return /thanksgiving/i.test((i.handle || '') + ' ' + (i.product_type || '')); }); }
  function apply(sheet) {
    var asap = sheet.querySelector('[data-when="asap"]'), later = sheet.querySelector('[data-when="later"]'),
        ds = sheet.querySelector('[data-day]'), ts = sheet.querySelector('[data-time]'), note = sheet.querySelector('.cg-r55-tg');
    if (!asap || !later || !ds || !ts) return;
    if (!tg) { asap.style.display = ''; if (note) note.remove(); return; }
    asap.style.display = 'none';
    later.click();
    ds.innerHTML = '<option value="tg">' + FULL + ' (Thanksgiving Day)</option>';
    ts.innerHTML = '';
    for (var m = FIRST; m <= LAST; m += STEP) { var o = document.createElement('option'); o.value = m; o.textContent = fmt(m); ts.appendChild(o); }
    ts.value = '720';
    if (!note) {
      note = document.createElement('p'); note.className = 'cg-r55-tg';
      note.style.cssText = 'margin:10px 0 0;font-size:13px;line-height:1.4;color:#7a3b00';
      note.textContent = 'Thanksgiving orders are ready on Thursday, November 26. Pick your pickup or delivery time.';
      ds.parentNode.parentNode.insertBefore(note, ds.parentNode.nextSibling);
    }
  }
  function check(sheet) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { tg = isTG(c); apply(sheet); }).catch(function () {});
  }
  function boot() {
    var sheet = document.getElementById('cgoc-sheet'); if (!sheet) return;
    new MutationObserver(function () { if (!sheet.hidden) check(sheet); }).observe(sheet, { attributes: true, attributeFilter: ['hidden'] });
    window.addEventListener('click', function (e) {
      if (!tg || sheet.hidden) return;
      var go = e.target.closest && e.target.closest('#cgoc-sheet [data-go]'); if (!go) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var m = +sheet.querySelector('[data-time]').value || 720, hh = Math.floor(m / 60), mm = m % 60;
      var lbl = FULL + ', ' + fmt(m);
      var attrs = { 'Pickup Time': lbl, 'Pickup Time ISO': ISO + 'T' + (hh < 10 ? '0' : '') + hh + ':' + (mm < 10 ? '0' : '') + mm + ':00',
        'Requested Time': lbl, 'Order Timing': 'Scheduled', 'Scheduled Date': ISO, 'Scheduled Time': fmt(m), 'Channel': 'catering', 'Catering Order': 'Yes' };
      go.disabled = true; go.textContent = 'One sec...';
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
        .then(function () { try { sessionStorage.setItem('cg_time_ok', '1'); } catch (x) {} location.href = '/checkout'; })
        .catch(function () { go.disabled = false; go.textContent = 'Continue to checkout'; });
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
